import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/border.css'
import './assets/styles/reset.css'
import './assets/styles/icon.css'
import fastClick from 'fastclick'
fastClick.attach(document.body)
fastClick.prototype.focus = function(targetElement) {
  　	'use strict'
    targetElement.focus()
}
import axios from 'axios'
Vue.prototype.$axios = axios
import config from './common/config';
Vue.prototype.$config = config

import { Toast  } from 'vant';
import 'vant/lib/toast/style';
Vue.use(Toast);


import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import 'swiper/dist/css/swiper.css'


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
